export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/table.f2918da7.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};